import { createContext, Dispatch, SetStateAction } from 'react';
import { UseQueryResult } from '@tanstack/react-query';

import { Revision } from '@api/editorialLayout/revisions';

import { RevisionId, RevisionMap } from '../../types';

export type RawDataRevisionValues = {
  canAddRevisionToCompare: boolean;
  filteredByHash?: string;
  getRevisionGroup: (hash: string) => Revision[] | undefined;
  groupedRevisions?: Record<string, Revision[]>;
  hasRepeatedMetadata: boolean;
  highlightedHash?: string;
  isLoading: boolean;
  isMuted: (hash: string) => boolean;
  queryResult: UseQueryResult<Revision[] | undefined>;
  revisions?: Revision[];
  revisionsToCompare: RevisionMap;
  setHighlightedHash: Dispatch<SetStateAction<string | undefined>>;
  sourceId?: string;
  toggleRevisionToCompare: (revisionId: RevisionId) => void;
};

const RawDataRevisionContext = createContext<RawDataRevisionValues>({
  canAddRevisionToCompare: false,
  getRevisionGroup: () => [],
  hasRepeatedMetadata: false,
  isLoading: false,
  isMuted: () => false,
  queryResult: {} as UseQueryResult<Revision[] | undefined>,
  revisionsToCompare: new Map(),
  setHighlightedHash: () => void 0,
  toggleRevisionToCompare: () => void 0,
});

export default RawDataRevisionContext;
